<div class="loading-overlay" [class.visible]="visible">
      <div class="loading-content">
        <div class="spinner"></div>
        <p class="loading-message" *ngIf="message">{{ message }}</p>
      </div>
    </div>
